import type { Dev } from '../../types/domain';

type BalanceSource = {
  previewMode?: boolean;
  viewAsDev?: Pick<Dev, 'soldeCp'> | null;
  profile?: { solde_cp?: number | null } | null;
};

// Solde CP affiché à l'utilisateur, le même sur « Mon profil » et « Congés ». Il se lit dans son
// propre profil : la liste de l'équipe chargée pour un non-manager (vue profiles_planning) ne
// contient pas les soldes, et la page Congés affichait 0. En aperçu, solde du membre prévisualisé.
export function ownLeaveBalance({ previewMode, viewAsDev, profile }: BalanceSource): number {
  return (previewMode ? viewAsDev?.soldeCp : profile?.solde_cp) || 0;
}
